<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><!-- <Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        > --></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-expand="expand"
    >
      <template slot-scope="{ row, index }" slot="imgPathArr">
        <viewer v-if="row.imgPathArr">
          <img
            v-for="(x, index) in row.imgPathArr"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="shoufu">
        <yingfuForm :data='row' @finish='getList'></yingfuForm>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openUpdateStatus(row, index)">状态</Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增数据' : '编辑数据'"
      width="1000"
      ref="formModel"
    >
      <Input
        v-model="item.ono"
        placeholder="请选择"
        slot="ono"
        @on-focus="openForm = true"
      ></Input>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <form-model title="更新付款状态" width="400" ref="updateStatus">
      <Button slot="btn" type="primary" @click="updateStatus">提交表单</Button>
    </form-model>
    <Modal v-model="openForm" title="订单号" footer-hide width="1000">
      <dingdanhao
        :scan="true"
        @obj="
          item.ono = $event.no;
          openForm = false;
        "
      ></dingdanhao>
    </Modal>
  </div>
</template>
<script>
var kehuitems = [];
import dingdanhao from "../fahuo/xitongkaidan.vue";
import yingfuChildList from "./yingfuChildList.vue";
import yingfuForm from "./yingfuForm.vue";
export default {
  components: { dingdanhao, yingfuChildList, yingfuForm },
  data() {
    return {
      isAdd: false,
      openForm: false,
      columns: [
        {
          type: "expand",
          width: 70,
          align: "center",
          render: (h, data) => {
            var that = this;
            return h(yingfuChildList, {
              //局部注册组件不需要加引号
              props: {
                data: data.row.ordersChargesList,
                columns: this.ordersChargesListForms,
              },
              on: {
                finish(e) {
                  that.getList();
                },
              },
            });
          },
        },
        {
          title: "状态",
          key: "status2",
          sort: 3.2,
        },
        {
          title: "应付总金额",
          key: "money",
          sort: 3.3,
        },
        /* {
          title: "操作",
          slot: "action",
          width: 180,
          align: "center",
          fixed: "right",
          sort: 50,
        }, */
      ],
      tableData: [],
      item: {
        cid: "",
        customer: "",
        ono: "",
        no: "",
        contact: "",
        tel: "",
        carType: "",
        tradeType: "",
        bpMode: 0,
        money: 0,
        currency: "",
        saleman: "",
        salemanAccount: "",
        imgPath: "",
        imgPathArr: [],
        processTime: "",
        remark: "",
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      forms: [
        {
          title: "订单号",
          key: "ono",
          required: "true",
          slotForm: "ono",
          width: 150,
        },
        {
          title: "客户名称",
          key: "cid",
          key2: "customer",
          required: true,
          type: "Select",
          selectType: "obj",
          selectItems: kehuitems,
        },
        {
          title: "客户单号",
          key: "customerNo",
        },
        {
          title: "已付总金额",
          key: "moneyReal",
          slot:'shoufu',
          required: "true",
          type: "InputNumber",
        },
        {
          title: "币别",
          key: "currency",
          required: "true",
          type: "Select",
          selectItems: this.lydic.getA("mType"),
        },
        {
          title: "账单号",
          key: "no",
          required: false,
          type: "Input",
        },

        {
          title: "联系人",
          key: "contact",
          required: false,
          type: "Input",
        },
        {
          title: "电话",
          key: "tel",
          required: false,
          type: "Input",
        },
        {
          title: "车辆类型",
          key: "carType",
          required: true,
          type: "Select",
          selectItems: this.lydic.getA("cartype"),
        },
        {
          title: "贸易类型",
          key: "tradeType",
          required: "true",
          type: "Select",
          selectItems: ["进口", "出口"],
        },
        {
          title: "业务类型",
          key: "bpMode",
          key2: "bpMode2",
          required: "true",
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["bpMode"],
        },

        {
          title: "业务员",
          key: "salemanAccount",
          key1: "saleman",
          required: false,
          type: "selectUser",
        },
        {
          title: "票据上传",
          key: "imgPathArr",
          slot: "imgPathArr",
          required: false,
          type: "lyPhoto",
        },
        {
          title: "付款日期",
          key: "processTime",
          key2: "processTime2",
          required: false,
          width: 130,
          type: "lyyymmdd",
        },
        {
          title: "备注",
          key: "remark",
          required: false,
          val: "",
          type: "Input",
        },
      ],
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
        {
          title: "客户名称",
          key: "cid",
          type: "Select",
          selectType: "obj",
          selectItems: kehuitems,
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
      ],
      ordersChargesListForms: [
        {
          title: "订单号",
          key: "ono",
          width: 150,
        },
        {
          title: "收费项目",
          key: "name",
        },{
          title: "币别",
          key: "currencyForeign",
        },
        {
          title: "应付（外币）",
          key: "payAmountForeign",
        },
        {
          title: "应付（人民币）",
          key: "payAmount",
        },
        {
          title: "审核人",
          key: "auditor",
        },
        {
          title: "备注",
          key: "remark",
        },
        {
          title: "费用来源",
          key: "type2",
        },
      ],
      updateStatusItem: {
        status: 0,
        id: "",
      },
      updateStatusForms: [
        {
          title: "付款状态",
          key: "status",
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic.yingfuStatus,
          required: true,
        },
      ],
      nowexpand: [],
    };
  },
  //http://59.37.161.185:8090/#/locate?now=1
  methods: {
    getList() {
      //记录展开的条目
      var t = this.tableData;
      this.nowexpand = [];
      for (let i = 0; i < t.length; i++) {
        if (t[i]._expanded) {
          this.nowexpand.push(i);
        }
      }
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/accountsPayable/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        var type = {
          0: "常规",
          1: "司机上传",
        };
        for (let i = 0; i < data.length; i++) {
          data[i]._expanded = false;
          data[i].index = i;
          data[i].bpMode2 = this.lydic.getVal("bpMode", data[i].bpMode);
          data[i].status2 = this.lydic.getVal("yingfuStatus", data[i].status);
          data[i].processTime2 = this.utils.time(data[i].processTime, "yymmdd");
          data[i].imgPathArr = this.utils.strToJson(data[i].imgPath);
          var ordes = data[i].ordersChargesList;
          for (let j = 0; j < ordes.length; j++) {
            ordes[j].status2 = this.lydic.getVal("status", 1);
            ordes[j].type2 = type[ordes[j].type];
          }
        }
        this.tableData = data;
        console.log('应付账款',data);
        //展开之前的条目
        for (let i = 0; i < this.nowexpand.length; i++) {
          this.tableData[i]._expanded = true;
        }
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      var aaa = this.utils.findObj(kehuitems, "id", a.cid);
      this.item.customer = aaa.name;
      a.imgPath = this.utils.jsonToStr(a.imgPathArr);
      this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-fms/accountsPayable/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url:
            this.axios.ipPort + "/cloud-tms-server-fms/accountsPayable/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url:
              this.axios.ipPort + "/cloud-tms-server-fms/accountsPayable/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    openUpdateStatus(row) {
      this.updateStatusItem.id = row.id;
      this.updateStatusItem.status = row.status;
      this.$refs.updateStatus.reach(
        this.updateStatusForms,
        this.updateStatusItem
      );
    },
    updateStatus(name) {
      var a = this.$refs.updateStatus.getItem();

      if (!a) {
        return;
      }
      this.updateStatusItem = a;
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-fms/accountsPayable/updateStatus",
        data: this.updateStatusItem,
      }).then((res) => {
        if (res) {
          this.$refs.updateStatus.close();
          this.getList();
        }
      });
    },

    expand(row, t) {
      this.tableData[row.index]._expanded = t;
    },
    kehuList() {
      kehuitems.splice(0, 1000);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name,
          };
          kehuitems.push(obj);
        }
      });
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 240,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    this.kehuList();
    //
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/yingfuzhangkuan.vue